module.exports = __webpack_public_path__ + "static/media/car-alt.301890c0.svg";